// src/pages/GaleriProyek.jsx
import React, { useState } from 'react';
import { Link } from 'react-router-dom';

// Data Proyek Dummy (Anda bisa mengganti ini dengan data asli Anda)
const projects = [
  {
    id: 'smart-farm-irigasi',
    name: 'Sistem Irigasi Otomatis Berbasis IoT',
    category: 'Smart Farming',
    description: 'Implementasi sistem irigasi cerdas yang mengoptimalkan penggunaan air berdasarkan sensor kelembaban tanah dan prakiraan cuaca.',
    image: 'https://via.placeholder.com/600x400/87CEEB/FFFFFF?text=Smart+Farm+Irigasi',
    detailsLink: '/proyek-kami/detail/smart-farm-irigasi' // Contoh link detail jika ada halaman khusus
  },
  {
    id: 'automasi-rumah',
    name: 'Integrasi Rumah Pintar Komprehensif',
    category: 'Smart Home',
    description: 'Solusi automasi rumah lengkap untuk kontrol pencahayaan, suhu, keamanan, dan perangkat elektronik melalui satu aplikasi.',
    image: 'https://via.placeholder.com/600x400/9370DB/FFFFFF?text=Smart+Home+Integrasi',
    detailsLink: '/proyek-kami/detail/automasi-rumah'
  },
  {
    id: 'depot-air-monitoring',
    name: 'Pemantauan Kualitas Air Depot Cerdas',
    category: 'Depot Air Cerdas',
    description: 'Sistem pemantauan real-time untuk kualitas air (pH, TDS, suhu) dan tingkat volume tangki pada depot air minum.',
    image: 'https://via.placeholder.com/600x400/6A5ACD/FFFFFF?text=Depot+Air+Monitoring',
    detailsLink: '/proyek-kami/detail/depot-air-monitoring'
  },
  {
    id: 'smart-watering-kebun',
    name: 'Sistem Penyiraman Otomatis Kebun Skala Kecil',
    category: 'Smart Watering',
    description: 'Automatisasi penyiraman untuk kebun rumah tangga atau perkebunan kecil, menghemat air dan waktu.',
    image: 'https://via.placeholder.com/600x400/4169E1/FFFFFF?text=Smart+Watering+Kebun',
    detailsLink: '/proyek-kami/detail/smart-watering-kebun'
  },
  {
    id: 'konsultasi-manufaktur',
    name: 'Studi Kasus: Optimalisasi Manufaktur dengan IoT',
    category: 'Konsultasi Proyek',
    description: 'Menganalisis dan memberikan rekomendasi solusi IoT untuk meningkatkan efisiensi operasional pabrik manufaktur.',
    image: 'https://via.placeholder.com/600x400/1E90FF/FFFFFF?text=Optimalisasi+Manufaktur',
    detailsLink: '/proyek-kami/detail/konsultasi-manufaktur'
  },
  {
    id: 'sensor-pertanian',
    name: 'Penerapan Sensor untuk Pertanian Presisi',
    category: 'Smart Farming',
    description: 'Pemasangan dan integrasi berbagai sensor (tanah, iklim) untuk pertanian presisi, memberikan data akurat untuk keputusan cerdas.',
    image: 'https://via.placeholder.com/600x400/20B2AA/FFFFFF?text=Sensor+Pertanian',
    detailsLink: '/proyek-kami/detail/sensor-pertanian'
  },
];

const categories = ['Semua Kategori', 'Smart Farming', 'Smart Home', 'Depot Air Cerdas', 'Smart Watering', 'Konsultasi Proyek'];

const GaleriProyek = () => {
  const [selectedCategory, setSelectedCategory] = useState('Semua Kategori');

  const filteredProjects = selectedCategory === 'Semua Kategori'
    ? projects
    : projects.filter(project => project.category === selectedCategory);

  return (
    <div className="bg-gray-100 dark:bg-gray-900 text-gray-800 dark:text-gray-200 min-h-screen py-16 transition-colors duration-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

        {/* Hero Section Galeri Proyek */}
        <section className="text-center mb-12">
          <h1 className="text-4xl md:text-5xl font-extrabold text-blue-700 dark:text-blue-400 leading-tight mb-4">
            Galeri Proyek & Studi Kasus
          </h1>
          <p className="text-lg md:text-xl max-w-3xl mx-auto text-gray-700 dark:text-gray-300">
            Lihatlah bagaimana kami telah mengubah ide menjadi solusi IoT nyata untuk berbagai industri.
          </p>
        </section>

        {/* Filter Kategori */}
        <section className="mb-12 bg-white dark:bg-gray-800 p-4 rounded-lg shadow-md transition-colors duration-300">
          <div className="flex flex-wrap justify-center gap-2 md:gap-4">
            {categories.map(category => (
              <button
                key={category}
                onClick={() => setSelectedCategory(category)}
                className={`px-4 py-2 rounded-full text-sm font-medium transition-colors duration-200
                  ${selectedCategory === category
                    ? 'bg-blue-600 text-white shadow-md'
                    : 'bg-gray-200 text-gray-700 hover:bg-gray-300 dark:bg-gray-700 dark:text-gray-200 dark:hover:bg-gray-600'
                  }`}
              >
                {category}
              </button>
            ))}
          </div>
        </section>

        {/* Daftar Proyek */}
        <section>
          {filteredProjects.length === 0 ? (
            <p className="text-center text-lg py-10 bg-white dark:bg-gray-800 rounded-lg shadow-md">Tidak ada proyek yang sesuai dengan kategori ini.</p>
          ) : (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
              {filteredProjects.map(project => (
                <div key={project.id} className="bg-white dark:bg-gray-800 rounded-lg shadow-md overflow-hidden transform hover:scale-105 transition-all duration-300">
                  <img
                    src={project.image}
                    alt={project.name}
                    className="w-full h-48 object-cover"
                  />
                  <div className="p-6">
                    <h3 className="text-xl font-semibold text-gray-900 dark:text-gray-100 mb-2 truncate">
                      {project.name}
                    </h3>
                    <p className="text-blue-600 dark:text-blue-400 text-sm font-medium mb-3">
                      {project.category}
                    </p>
                    <p className="text-gray-600 dark:text-gray-300 text-sm mb-4">
                      {project.description}
                    </p>
                    {/* Link ke halaman detail proyek, jika ada */}
                    {project.detailsLink && (
                      <Link
                        to={project.detailsLink}
                        className="inline-block bg-blue-500 text-white px-4 py-2 rounded-full hover:bg-blue-600 transition text-sm"
                      >
                        Lihat Studi Kasus
                      </Link>
                    )}
                  </div>
                </div>
              ))}
            </div>
          )}
        </section>

        {/* CTA Section (opsional, bisa seperti di Beranda) */}
        <section className="text-center mt-16 bg-blue-600 dark:bg-blue-900 text-white p-8 rounded-lg shadow-lg">
          <h2 className="text-3xl font-bold mb-4">Punya Ide Proyek?</h2>
          <p className="text-lg mb-6">
            Kami siap membantu Anda mewujudkannya. Hubungi kami untuk konsultasi gratis.
          </p>
          <Link to="/kontak/formulir">
            <button className="bg-white text-blue-600 dark:bg-blue-200 dark:text-blue-900 font-semibold px-8 py-3 rounded-full shadow-lg hover:bg-gray-100 transform hover:scale-105 transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-white focus:ring-opacity-50">
              Mulai Proyek Baru
            </button>
          </Link>
        </section>

      </div>
    </div>
  );
};

export default GaleriProyek;